import { Component, Input } from '@angular/core';
import { FabricComposition } from '../../../models/greige/greige';
import { Composition } from '../../../models/composition/composition';
import { LocaleHelperService } from '../../../services/localehelperservice.service';

@Component({
  selector: 'app-card-composition',
  templateUrl: './card-composition.component.html',
  styleUrl: './card-composition.component.scss',
})
export class CardCompositionComponent {
  @Input() fabricComposition: FabricComposition[] = [];
  @Input() allCompositions: Composition[] = [];

  constructor(private localeHelperService: LocaleHelperService) {}

  getCompositionColor(compositionCode: string): string {
    if (!compositionCode) {
      return '#777'; // Default color for unknown compositions
    }
    switch (compositionCode.toLowerCase()) {
      case 'cotton':
        return '#001a70';
      case 'poly':
        return '#ef4444';
      case 'recycledblackpoly':
        return '#5fa535';
      case 'rayon':
        return '#009999';
      case 'blackpoly':
        return '#5AA29D';
      case 'polyrecycle':
        return '#5AA29D';
      default:
        return '#777';
    }
  }

  getCompositionName(code: string): string {
    const composition = this.allCompositions.find((c) => c.code!.toLowerCase() === code.toLowerCase());
    const name = composition ? this.localeHelperService.getLocalizedValue(composition.name) : code;
    return name.toUpperCase();
  }
}
